import { useRef, useState, useEffect, useCallback } from "react";

const FullscreenIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
    <path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7" />
  </svg>
);

/** Tempo (ms) que o botão fica visível após o mouse se mover */
const HIDE_DELAY = 500;

export default function FullscreenButton({ children }) {
  const containerRef = useRef(null);
  const hideTimer = useRef(null);
  const isPlayingRef = useRef(false);

  const [showButton, setShowButton] = useState(true);                    
  const [isHovered, setIsHovered] = useState(false);                



  // Exibe o botão e agenda para esconder se o vídeo estiver rodando
  const handleInteraction = useCallback(() => {
    setShowButton(true);
    clearTimeout(hideTimer.current);

    // setTimeout: Ferramenta do navegador para "agendar uma ação para o futuro"

    if (isPlayingRef.current && !isHovered) {
      hideTimer.current = setTimeout(() => setShowButton(false), HIDE_DELAY);
    }
  }, [isHovered]); // Só vai executar se isHovered mudar



  // Alterna o modo Fullscreen
  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      containerRef.current?.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
  };



  // Escuta as mensagens do Iframe do Panda Video
  useEffect(() => {
    const onMessage = (e) => {
      const msg = typeof e.data === 'string' ? e.data : e.data?.message;

      if (msg === 'panda_play') {
        isPlayingRef.current = true;
        handleInteraction();
      } else if (msg === 'panda_pause' || msg === 'panda_ended') {
        isPlayingRef.current = false;
        setShowButton(true);
        clearTimeout(hideTimer.current);
      }
    };

    window.addEventListener('message', onMessage);
    return () => {
      window.removeEventListener('message', onMessage);
      clearTimeout(hideTimer.current);
    };
  }, [handleInteraction]);



  return (
    <div
      ref={containerRef}
      onMouseMove={handleInteraction}
      style={{
        position: 'relative', 
        width: '100%',
        height: '100%',
        background: 'black',
      }}
    >
      {/* Iframe do Panda Video */}
      {children}

      {/* Camada invisível para capturar o mouse quando o iframe "engole" os eventos */}
      {!showButton && (
        <div
          onMouseMove={handleInteraction}
          onClick={handleInteraction} // Acorda a UI também ao clicar
          style={{
            position: 'absolute',
            inset: 0,
            zIndex: 9998, // Fica logo atrás do botão de fullscreen
          }}
        />
      )}

      {/* Botão de fullscreen */}
      <button
        onClick={toggleFullscreen}
        onMouseEnter={() => { setIsHovered(true); clearTimeout(hideTimer.current); setShowButton(true); }}
        onMouseLeave={() => { setIsHovered(false); handleInteraction(); }}
        title="Fullscreen"
        style={{
          position: 'absolute',
          bottom: 13,
          right: 150,
          zIndex: 9999,
          background: isHovered ? '#969594' : 'transparent',
          border: 'none',
          borderRadius: 3,
          padding: '5px 6px',
          cursor: 'pointer',
          opacity: showButton ? 1 : 0,
          pointerEvents: showButton ? 'auto' : 'none',
          transition: 'opacity 0.3s',
        }}
      >
        <FullscreenIcon />
      </button>
    </div>
  );
}